import classNames from "classnames"
import React from "react"

import s from "./Form.module.scss"

export default function TextArea({
  className,
  errorMessage,
  label,
  name,
  onChange,
  value,
}) {
  const id = `field-${name}`
  return (
    <div
      className={classNames(s.formField, className, {
        [s.error]: errorMessage,
      })}
    >
      <label htmlFor={id}>{label}</label>
      <textarea id={id} name={name} onChange={onChange} value={value} />
      {errorMessage ? (
        <span className={s.errorLabel}>{errorMessage}</span>
      ) : null}
    </div>
  )
}
